import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class DeclaracionControlService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    realizarPago(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: declaracion_controlInputType) {
          declaracion_control {
            realizarPago(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                empresa_rut
                sucursal_codigo
                vendedor_codigo
                chofer_rut
                cliente_proveedor_rut
                otro
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.declaracion_control.realizarPago;
            callback({ mensajes, respuesta });
        });
    }
}
DeclaracionControlService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DeclaracionControlService_Factory() { return new DeclaracionControlService(i0.ɵɵinject(i1.GraphQLClient)); }, token: DeclaracionControlService, providedIn: "root" });
